export const COSTA_RICA = '005';

export default COSTA_RICA;
